import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil, map } from 'rxjs';

@Component({
  selector: 'app-post-stay-stuned',
  templateUrl: './post-stay-stuned.component.html',
  styleUrls: ['./post-stay-stuned.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostStayStunedComponent implements OnInit {
  @Input() public data: any[] = [];

  public showDesktop$: Observable<boolean>;

  private _destroy$ = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver) {}

  public ngOnInit() {
    this.showDesktop$ = this.breakpointObserver.observe('(min-width: 1280px)').pipe(
      takeUntil(this._destroy$),
      map((state) => state.matches),
    );
  }

  public bannerLink(params: string) {
    return `https://s.educacaoadventista.org.br/escola/conteudos/${params}`;
  }
}
